import React from "react";

import {StandingsWidgetCollapsed} from "./standings-widget.collapsed";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {StandingsWidgetController} from "../standings-widget.controller";
import {StandingsWidgetProps} from "../models/standings-widget.props";
import {StandingsWidgetContent} from "./standings-widget-content";
import {Dropdown} from "../../../core/components/dropdown/dropdown";
import {ListEntityItem} from "../../../core/components/misc/list/list.entity-item";
import {CompetitorStandingsCompetitionViewModel} from "../../competitor-standings-widget/models/competitor-standings-competition.view-model";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {ENTITY_SCORES} from "../../entity-scores-widget/entity-scores-widget.consts";
import styles from "../styles/standings-widget.module.scss";
import classnames from "classnames";
import {StandingsWidgetOutrights} from "./standings-widget.outrights";
import {StandingsWidgetBookmakersReview} from "./standings-widget.bookmakers-review";
import {TagSnippetWidgetAsync} from "../../tag-snippet-widget/components/tag-snippet-widget.async";
import type {StandingsSeasonsFilterViewModel} from "../../../domain/standings/models/seasons-filter/standings.seasons-filter.view-model";
import {StandingsWidgetEntityDescription} from "./standings-widget.entity-description";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export const StandingsWidgetComponent = ({
                                           controller,
                                           source,
                                           competitionIds,
                                           isPreviewStandings,
                                           collapsedCompetitorIds,
                                           context
                                         }: StandingsWidgetProps) => {
  const {state, device: {isSmallView}} = controller;
  const {
    isCollapsed,
    selectedCompetitionId,
    competitions,
    isStandingsPage,
    isWidget,
    seasonsFilter,
    currentFilterSeasonNum
  } = state;

  const baseProps = {
    source,
    controller,
    competitionIds,
    isPreviewStandings,
    collapsedCompetitorIds
  }

  const grayPrimary = useThemeColor(COLORS.grayPrimary);

  const competitionDropdownProps = {
    items: seasonsFilter,
    selectedValue: currentFilterSeasonNum,
    arrowColor: grayPrimary,
    blockScrolling: true,
    containerClassName: 'competitor-standings-widget-dropdown-container',
    headerClassName: seasonsFilter?.length > 1 ? 'competitor-standings-widget-dropdown-header' : 'competitor-standings-widget-single-header',
    itemClassName: 'competitor-standings-widget-dropdown-item',
    listClassName: 'standings-widget-dropdown-list',
    onChange: (season: StandingsSeasonsFilterViewModel) => controller.action(STANDINGS_WIDGET.ACTION_TYPES.onSeasonChange, {seasonNum: season.seasonNum}),
    listItemProps: {
      disableLink: true
    }
  }

  const competitorDropdownProps = {
    items: competitions,
    selectedValue: selectedCompetitionId,
    ListItem: ListEntityItem,
    arrowColor: grayPrimary,
    blockScrolling: true,
    containerClassName: 'competitor-standings-widget-dropdown-container',
    headerClassName: state.competitions > 1 ? 'competitor-standings-widget-dropdown-header' : 'competitor-standings-widget-single-header',
    itemClassName: 'competitor-standings-widget-dropdown-item',
    listClassName: 'standings-widget-dropdown-list',
    onChange: (competition: CompetitorStandingsCompetitionViewModel) => controller.action(STANDINGS_WIDGET.ACTION_TYPES.competitionChange, {competitionId: competition.id}),
    listItemProps: {
      disableLink: true
    }
  }

  const dropdownProps = context === ENTITY_SCORES.TYPES.competitor ? competitorDropdownProps : competitionDropdownProps;

  const additionalWidgetProps = {
    controller,
    isPreviewStandings,
    isCollapsed
  }

  const tagSnippetProps = {
    widgetType: 'entityStandings',
    source
  }

  return (
      <div className={classnames({[styles.page]: isStandingsPage, [styles.small_view]: isSmallView}, styles.container)}>
        {
          state.shouldRenderDropdown ?
              <Dropdown {...dropdownProps} /> : null
        }
        {
          isCollapsed ? <StandingsWidgetCollapsed {...baseProps}/> : <StandingsWidgetContent {...baseProps}/>
        }
        {
          isStandingsPage && !isWidget ? <TagSnippetWidgetAsync {...tagSnippetProps}/> : null
        }
        <StandingsWidgetOutrights {...additionalWidgetProps}/>
        <StandingsWidgetBookmakersReview {...additionalWidgetProps}/>
        <StandingsWidgetEntityDescription {...additionalWidgetProps}/>
      </div>
  )

};

const settings: ComposeSettings = {
  component: StandingsWidgetComponent,
  propsType: StandingsWidgetProps,
  controllerType: StandingsWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,
  observe: true,
}

export default Compose(settings);
